import { render, staticRenderFns } from "./QuickLottoBoard.vue?vue&type=template&id=916c0cc6&scoped=true&"
import script from "./QuickLottoBoard.vue?vue&type=script&lang=js&"
export * from "./QuickLottoBoard.vue?vue&type=script&lang=js&"
import style0 from "./QuickLottoBoard.vue?vue&type=style&index=0&id=916c0cc6&scoped=true&lang=scss&"
import style1 from "./QuickLottoBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916c0cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFlex,VImg,VRow})
